export enum SeparatorType {
  Comma = ',',
  Dot = '.',
  NonBreakingSpace = ' ',
  Space = ' ',
}
